import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMAIL_ALREADY_EXIST, KEY_POST_EMAIL_ALREADY_EXIST } from '../constants';
import { MOCK_RESPONSE_POST_EMAIL_ALREADY_EXIST } from '../mocks';

type RequestPostEmailAlreadyExist = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY
>['request']['body'];

type ResponsePostEmailAlreadyExist = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY
>['response']['body'];

export type CallParamsPostEmailAlreadyExist = RequestPostEmailAlreadyExist & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmailAlreadyExist = ResponsePostEmailAlreadyExist;

type CallErrorPostEmailAlreadyExist = GenericApiError;

type CallSelectorsPostEmailAlreadyExist = {
  emailAlreadyExist?: CallResponsePostEmailAlreadyExist;
};

export const postEmailAlreadyExistCall = createGeneralCall<
  CallParamsPostEmailAlreadyExist,
  CallResponsePostEmailAlreadyExist,
  CallErrorPostEmailAlreadyExist,
  CallSelectorsPostEmailAlreadyExist
>({
  id: KEY_POST_EMAIL_ALREADY_EXIST,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_EMAIL_ALREADY_EXIST(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        email: payload.email,
      };
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMAIL_ALREADY_EXIST : undefined,
  selectors: {
    emailAlreadyExist: ({ selectors }) =>
      createSelector(selectors.response, res => {
        // res might return an empty object which is truthy, so this check forces the selector to a boolean with correct data
        return res === true;
      }),
  },
});
